module.exports = new __parcel__URL__("Charlie_Display-Thin.53f6ff2a.woff2").toString();